import { getCookieConsentValue } from 'react-cookie-consent';

export const COOKIE_CONSENT_NAME = 'cookieConsent';

// THE BANNER SAVES 'true' OR 'false'. NO COOKIE MEANS THE VISITOR HAS NOT ANSWERED
export const isAnalyticsConsentGranted = () =>
  getCookieConsentValue(COOKIE_CONSENT_NAME) === 'true';

export const isAnalyticsConsentRefused = () =>
  getCookieConsentValue(COOKIE_CONSENT_NAME) === 'false';
